import React, { useEffect } from "react";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import "../assets/css/main.css";
// import Swiper JS

// import Swiper styles
import "swiper/css";

function TestimonialsComponent() {
  useEffect(() => {
    new Swiper(".init-swiper", {
      loop: true,
      speed: 600,
      autoplay: {
        delay: 5000,
      },
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  }, []);

  return (
    <div class="container my-5 py-5" id="testimonials">
      <div className=" section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>What Our Clients Say</p>
      </div>
      <div class="row g-5">
        <div class="col-lg-6 col-md-12">
          <div class="testimonial-block mb-5">
            <p class="quote-text">
              Cleonatech transformed our idea into a complete product with
              flawless execution. Their communication, speed, and technical
              expertise were outstanding. We always felt supported throughout
              the entire development cycle.{" "}
            </p>
            <p class="author-name">— Arun Kumar, CEO, BlueWave Solutions </p>
          </div>

          <div class="testimonial-block mb-5">
            <p class="quote-text">
              We chose Cleonatech because of their reputation for quality—and
              they exceeded every expectation. Their UI/UX work was clean,
              modern, and highly optimized for performance. Truly a world-class
              team.{" "}
            </p>
            <p class="author-name">
              — Nimasha Perera, Product Manager, FastCart.lk{" "}
            </p>
          </div>

          <div class="testimonial-block mb-5">
            <p class="quote-text">
              Working with Cleonatech saved us months of development time. They
              brought strategic insights, strong engineering, and a
              problem-solver mindset. We’ll definitely continue future projects
              with them.{" "}
            </p>
            <p class="author-name">
              — Melissa D’Souza, CTO, BrightLine Retail{" "}
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="testimonial-block mb-5">
            <p class="quote-text">
              Their mobile app development expertise is exceptional. The final
              app is fast, stable, and beautifully designed. Our users love it,
              and our business saw immediate growth after launch.
            </p>
            <p class="author-name">
              — Suresh Balachandran, Director, HealthHub Digital
            </p>
          </div>

          <div class="testimonial-block mb-5">
            <p class="quote-text">
              From the first meeting to final delivery, Cleonatech showed deep
              industry knowledge and genuine commitment. Our custom ERP system
              now runs smoother than ever. Highly recommended!
            </p>
            <p class="author-name">
              — Jason Matthews, Operations Head, NorthStar Logistics{" "}
            </p>
          </div>

          <div class="testimonial-block mb-5">
            <p class="quote-text">
              Team Cleonatech is reliable, transparent, and efficient. They
              provided weekly updates, delivered milestones on time, and adapted
              quickly to changing requirements. A great long-term tech partner.{" "}
            </p>
            <p class="author-name">
              — Hiruni Fernando, Founder, EduRise Academy{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsComponent;
